import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


const routes: Routes = [

  {
    path: '',
    loadChildren: () => import('./features/creatics/creatics.module').then(m => m.CreaticsModule),
  },

  {
    path: 'cinejoy',
    loadChildren: () => import('./features/cinejoy/cinejoy.module').then(m => m.CinejoyModule),
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})], // remove tracing before production
  exports: [RouterModule]
})
export class AppRoutingModule { }
